// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-25WsV";
var _3 = "title-12DV2";
var _4 = "content-37Aht";
var _5 = "content__text-1KWSJ";
var _6 = "inner-2Q52c";
var _7 = "icon-BYyi6";
var _8 = "links-2wLmE";
var _9 = "link-1heyW";
export { _1 as "__esModule", _2 as "wrapper", _3 as "title", _4 as "content", _5 as "content__text", _6 as "inner", _7 as "icon", _8 as "links", _9 as "link" }
export default { "__esModule": _1, "wrapper": _2, "title": _3, "content": _4, "content__text": _5, "inner": _6, "icon": _7, "links": _8, "link": _9 }
